import {
    BlogsImageDetailPage,
    BlogsImageDetailViewType,
    OwnProps,
    Props,
    RouteProps,
    StateProps,
} from 'mk2/apps/blogs/containers/BlogsImageDetail/BlogsImageDetailPage';
import { blogsShortMessageUrl } from 'mk2/apps/blogs/urls';
import { url } from 'mk2/helpers/urls';
import { AppState } from 'mk2/reducers';
import { MapStateToPropsParam } from 'react-redux';

export default class BlogsShortMessageImageDetailPage extends BlogsImageDetailPage {

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            return {
                ...super.mapStateToProps()(state, ownProps) as StateProps,
                viewType: BlogsImageDetailViewType.ShortMessage,
            };
        };
    }

    public getDefaultBackPath(props: Props): string {
        const { match: { params: { username, postSlug } } } = props;
        return url(blogsShortMessageUrl, { username, postSlug });
    }
}
